import styled from 'styled-components/macro';
import { TitleStyled, Accordion } from '@yme/atoms/accordion';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTextStyles } from '@yme/utils/styles';
export const FaqWrapperStyled = styled.div `
  ${TitleStyled} {
    ${getTextStyles('Ubuntu', 500, 18, 28)}
  }
`;
export const FaqContentWrapperStyled = styled.div `
  ${({ isRightToLeft }) => (isRightToLeft ? 'padding-left' : 'padding-right')}: 18px;
  ${ADAPTIVE.minWidth.desktop} {
    max-width: 756px;
    padding: 0;
  }
`;
export const ProductDetailsListStyled = styled.ul `
  margin: 0;
  padding-left: 32px;
`;
export const ProductDetailsItemStyled = styled.li `
  ${getTextStyles('Ubuntu', null, 16, 24)}

  color: ${colorCoreBlack300};
`;
export const AccordionStyled = styled(Accordion) `
  padding: 32px 0;

  ${ADAPTIVE.maxWidth.mobile} {
    padding: 24px 0;
  }
`;
